import { PortableText } from '@portabletext/react'
import Link from '@/components/Link/Link'
import styles from './RichText.module.scss'

const portableTextSerializer = {
  block: {
    normal: ({ children }) => <p data-p>{children}</p>,
    h1: ({ children }) => <h1 data-h1>{children}</h1>,
    h2: ({ children }) => <h2 data-h2>{children}</h2>,
    h3: ({ children }) => <h3 data-h3>{children}</h3>,
    h4: ({ children }) => <h4 data-h4>{children}</h4>,
  },
  listItem: {
    bullet: ({ children }) => (
      <li
        className={styles.li}
        data-li
      >
        {children}
      </li>
    ),
  },
  list: {
    bullet: ({ children }) => (
      <ul
        className={styles.ul}
        data-ul
      >
        {children}
      </ul>
    ),
  },
  marks: {
    indentItalic: ({ text }) => {
      return (
        <i
          className={styles.indexItalic}
          data-indent-italic
        >
          {text}
        </i>
      )
    },
    link: ({ value, text }) => {
      return (
        <Link
          link={{
            ...value,
            label: text,
          }}
        />
      )
    },
  },
}

const RichText = ({ content }) => {
  return (
    <PortableText
      value={content}
      onMissingComponent={false}
      components={portableTextSerializer}
    />
  )
}

RichText.displayName = 'RichText'

export default RichText
